import { StoredNextCheckIntentionSchema } from "./next-check.js";
import { z } from "zod";
const CrmExternalIdSchema = z.string().regex(/^[1-9][0-9]{0,15}$/u);
/**
 * Owner action «Вернуть лид Яне / поставить проверку». It never writes to the
 * customer: it schedules one Yana next check (and, for a closed-lost deal,
 * first moves the deal to a Yana working stage through the reviewed CRM outbox).
 */
export const OwnerLeadReturnMutationSchema = z.object({
    targetCrmStageExternalId: CrmExternalIdSchema.nullable().optional(),
    wakeAt: z.string().datetime({ offset: true }),
    intention: z.string().trim().min(5).max(600),
    reason: z.string().trim().min(5).max(600),
    idempotencyKey: z.string().min(16).max(160),
}).strict();
// turn_started (352): Yana had no reviewed package in this chat or the client
// never wrote; instead of a refusal she took the dialogue now, with the owner's
// intention and requested time, by the scenario.
export const OwnerLeadReturnStateSchema = z.enum(["stage_pending", "scheduled", "failed", "turn_started"]);
export const OwnerLeadReturnResultSchema = z.object({
    returnId: z.string().uuid(),
    state: OwnerLeadReturnStateSchema,
    runId: z.string().uuid().nullable(),
    stageEffectCommandId: z.string().uuid().nullable(),
    wakeAt: z.string().datetime({ offset: true }).nullable(),
    targetCrmStageExternalId: CrmExternalIdSchema,
    replayed: z.boolean(),
    customerEffect: z.literal(false),
});
const StageOptionSchema = z.object({
    externalId: CrmExternalIdSchema,
    name: z.string().min(1).max(200),
});
export const OwnerLeadReturnOptionsSchema = z.object({
    conversationId: z.string().uuid(),
    currentStage: StageOptionSchema.nullable(),
    requiresTargetStage: z.boolean(),
    stageOptions: z.array(StageOptionSchema).max(100),
    defaultWakeAt: z.string().datetime({ offset: true }),
    activeCheck: z.object({
        wakeAt: z.string().datetime({ offset: true }),
        intention: StoredNextCheckIntentionSchema,
    }).nullable(),
    latestReturn: z.object({
        state: OwnerLeadReturnStateSchema,
        requestedWakeAt: z.string().datetime({ offset: true }),
        targetStageName: z.string().max(200).nullable(),
        lastErrorCode: z.string().regex(/^[A-Z0-9_]{1,120}$/u).nullable(),
        createdAt: z.string().datetime({ offset: true }),
    }).nullable(),
});
const MOSCOW_OFFSET_MS = 3 * 60 * 60 * 1_000;
/**
 * The next working morning, 10:00 Moscow time: today when it is still at
 * least 30 minutes away, otherwise the next weekday. Moscow has no DST.
 */
export function nextWorkingMorningMsk(now) {
    const moscow = new Date(now.getTime() + MOSCOW_OFFSET_MS);
    let candidate = Date.UTC(moscow.getUTCFullYear(), moscow.getUTCMonth(), moscow.getUTCDate(), 10) - MOSCOW_OFFSET_MS;
    const isWeekend = (instant) => {
        const day = new Date(instant + MOSCOW_OFFSET_MS).getUTCDay();
        return day === 0 || day === 6;
    };
    while (candidate < now.getTime() + 30 * 60 * 1_000 || isWeekend(candidate)) {
        candidate += 24 * 60 * 60 * 1_000;
    }
    return new Date(candidate);
}
//# sourceMappingURL=owner-lead-return.js.map